import { render } from "./RichBubble.vue?vue&type=template&id=86c88a66&scoped=true"
import script from "./RichBubble.vue?vue&type=script&lang=js"
export * from "./RichBubble.vue?vue&type=script&lang=js"

import "./RichBubble.vue?vue&type=style&index=0&id=86c88a66&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86c88a66"]])

export default __exports__